module.exports = __webpack_public_path__ + "img/spinner-circle-dark.730ace2b.svg";